import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  IconButton,
  Box,
  InputAdornment,
  useTheme,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";

import SupportImage from "../../../components/images/35PercOff.webp";
import { trackLead } from "../../../utils/fbConversion";

const inputStyle = {
  background: "#ffffff",
  borderRadius: "12px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    "& fieldset": {
      borderColor: "#e4e4e7",
    },
    "&:hover fieldset": {
      borderColor: "#b9b9c3",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#5e17eb",
    },
  },
};

const TalkToOurConsultantPopup = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ---------- ADDED FUNCTIONALITY ----------
  const [gclid, setGclid] = useState("");
  const [formError, setFormError] = useState("");
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    website: window.location.href.slice(0, 250),
    description: window.location.href.includes("full-stack-web-development")
      ? "Full Stack Web Development"
      : window.location.href.includes("devops-and-cloud-training-online")
      ? "DevOps and Cloud with GenAI Master Program"
      : "DevOps and Cloud with GenAI Job Ready Program",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const validateFirstName = (v) => (!v ? "First name is required" : "");
  const validateLastName = (v) => (!v ? "Last name is required" : "");
  const validateEmail = (v) => {
    if (!v) return "Email is required";
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(v) ? "" : "Invalid email address";
  };
  const validatePhone = (v) => {
    if (!v) return "Phone number is required";
    return /^\d{10}$/.test(v) ? "" : "Phone number must be 10 digits";
  };

  const handleChange = (e, field) => {
    const value = e.target.value;

    setFormValues((p) => ({ ...p, [field]: value }));

    let error = "";
    switch (field) {
      case "firstName":
        error = validateFirstName(value);
        break;
      case "lastName":
        error = validateLastName(value);
        break;
      case "email":
        error = validateEmail(value);
        break;
      case "phone":
        error = validatePhone(value);
        break;
      default:
        break;
    }

    setErrors((p) => ({ ...p, [field]: error }));
  };

  useEffect(() => {
    const urlGclid = new URLSearchParams(window.location.search).get("gclid");
    if (urlGclid) {
      localStorage.setItem("gclid", urlGclid);
      setGclid(urlGclid);
    } else {
      setGclid(localStorage.getItem("gclid"));
    }
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const firstNameError = validateFirstName(formValues.firstName);
    const lastNameError = validateLastName(formValues.lastName);
    const emailError = validateEmail(formValues.email);
    const phoneError = validatePhone(formValues.phone);

    if (firstNameError || lastNameError || emailError || phoneError) {
      setErrors({
        firstName: firstNameError,
        lastName: lastNameError,
        email: emailError,
        phone: phoneError,
      });
      setFormError(
        firstNameError || lastNameError || emailError || phoneError
      );
      return;
    }

    trackLead({
      contentName: "Talk to Our Consultant",
      email: formValues.email,
      phone: formValues.phone,
      firstName: formValues.firstName,
      lastName: formValues.lastName,
    });

    document.forms["WebToLeads774394000000936079"].submit();
  };

  // ---------- END FUNCTIONALITY ----------

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: "18px",
          overflow: "hidden",
        },
      }}
    >
      <IconButton
        aria-label="Close Eligibility Form"
        onClick={onClose}
        sx={{ position: "absolute", right: 14, top: 14, zIndex: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          {!isMobile && (
            <Box
              flex={1}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#ffffff",
              }}
            >
              <img
                loading="lazy"
                src={SupportImage}
                alt="Consultation Offer"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          )}

          <Box flex={1} sx={{ p: { xs: 3, md: 4 } }}>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35 }}
            >
              <Typography variant="h5" fontWeight={700} mb={1} sx={{ fontFamily: "Poppins, sans-serif" }}>
                Talk to our Consultant
              </Typography>

              <Typography color="text.secondary" mb={3}>
                Get a call back from our consultant within minutes.
              </Typography>

              {/* ---- FORM ---- */}
              <form
                id="webform774394000000936079"
                action="https://crm.zoho.in/crm/WebToLeadForm"
                name="WebToLeads774394000000936079"
                method="POST"
                onSubmit={handleFormSubmit}
                acceptCharset="UTF-8"
              >
                <input type="hidden" name="xnQsjsdp" value="1cad0140c50fbd72c59b39201ba5b81ab62e6995c725adf26f6aad1b8616e985" />
                <input type="hidden" name="xmIwtLD" value="2ac5e1702266b95f1281b8514c7dbe8cf46c2552f19b5adf6e506fc723eb7b83fff3cbccd67c12c9418dcb51b5fcb9b1" />
                <input type="hidden" name="actionType" value="TGVhZHM=" />
                <input type="hidden" name="returnURL" value="https://paperlive.in/thankyou" />
                <input type="hidden" id="zc_gad" name="zc_gad" value={gclid} />

                <Box sx={{ display: "grid", gap: "14px" }}>
                  <TextField
                    label="First Name"
                    id="First_Name"
                    name="First Name"
                    variant="outlined"
                    fullWidth
                    value={formValues.firstName}
                    onChange={(e) => handleChange(e, "firstName")}
                    error={!!errors.firstName}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AssignmentIndIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={inputStyle}
                  />

                  <TextField
                    label="Last Name"
                    id="Last_Name"
                    name="Last Name"
                    variant="outlined"
                    fullWidth
                    value={formValues.lastName}
                    onChange={(e) => handleChange(e, "lastName")}
                    error={!!errors.lastName}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AssignmentIndIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={inputStyle}
                  />

                  <TextField
                    label="Email"
                    id="Email"
                    name="Email"
                    type="email"
                    fullWidth
                    value={formValues.email}
                    onChange={(e) => handleChange(e, "email")}
                    error={!!errors.email}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={inputStyle}
                  />

                  <TextField
                    label="Phone Number"
                    id="Phone"
                    name="Phone"
                    type="tel"
                    fullWidth
                    value={formValues.phone}
                    onChange={(e) => handleChange(e, "phone")}
                    error={!!errors.phone}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIphoneIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={inputStyle}
                  />

                  {/* Hidden extra fields */}
                  <input type="hidden" id="Website" name="Website" value={formValues.website} />
                  <input type="hidden" id="Description" name="Description" value={formValues.description} />

                  <div style={{ color: "red" }}>{formError}</div>

                  <Button
                    aria-label="Submit Talk to Our Consultant Form"
                    variant="contained"
                    fullWidth
                    sx={{
                      fomtFamily: "Poppins, sans-serif",
                      mt: 1,
                      borderRadius: "12px",
                      fontWeight: 700,
                      height: 45,
                      textTransform: "none",
                      background: "#5e17eb",
                      ":hover": { background: "#4d13c6" },
                    }}
                    onClick={handleFormSubmit}
                  >
                    Submit
                  </Button>
                </Box>
              </form>
            </motion.div>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TalkToOurConsultantPopup;
